// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vy_gLZeC0BqEgMfcuC6N{line-height:1.5rem;overflow:hidden;height:100%;position:relative;margin-right:-12px}._IR6lXg9Fu6zJEAAnXAp{height:100%}.m74LlGrzr4rg4bJwEf2A{font-size:0.8333333333rem;color:#8496b9;margin-bottom:0.8333333333rem;text-align:center;width:100%;margin-top:2px}.U1eCokwn_PSEhLivUHZO{width:100%;height:100%;position:relative}.tK7X0np7ZP047Mincon8{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.tK7X0np7ZP047Mincon8>img{width:100%;height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"accordion": `Vy_gLZeC0BqEgMfcuC6N`,
	"gallery": `_IR6lXg9Fu6zJEAAnXAp`,
	"imageDescription": `m74LlGrzr4rg4bJwEf2A`,
	"video": `U1eCokwn_PSEhLivUHZO`,
	"content": `tK7X0np7ZP047Mincon8`
};
export default ___CSS_LOADER_EXPORT___;
